<template>
    <div class="training-lc-tiles">
        <training-learning-content-tile
            v-for="learningContent in learningContents"
            :key="learningContent.learningContent.id"
            :assignment="assignment"
            :course-progress="courseProgress"
            :learning-content="learningContent">
        </training-learning-content-tile>

        <div class="h:margin-top-4 h:margin-bottom-6" v-if="additionalCourseContents">
            <div class="bold h:margin-bottom-2">Zusatzinhalte</div>

            <div class="training-certificate-tile" :key="additionalCourseContent.id"
                 v-for="additionalCourseContent in additionalCourseContents">
                <div class="training-certificate-tile__icon"
                     :class="{'training-certificate-tile__icon--completed' : additionalCourseContent.viewed_by_current_user}">
                    <span v-if="additionalCourseContent.viewed_by_current_user">
                        <svg width="30" height="30" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.276923 10.1538C0.0923077 9.96923 0 9.69231 0 9.50769C0 9.32308 0.0923077 9.04615 0.276923 8.86154L1.56923 7.56923C1.93846 7.2 2.49231 7.2 2.86154 7.56923L2.95385 7.66154L8.03077 13.1077C8.21538 13.2923 8.49231 13.2923 8.67692 13.1077L21.0462 0.276923H21.1385C21.5077 -0.0923077 22.0615 -0.0923077 22.4308 0.276923L23.7231 1.56923C24.0923 1.93846 24.0923 2.49231 23.7231 2.86154L8.95385 18.1846C8.76923 18.3692 8.58462 18.4615 8.30769 18.4615C8.03077 18.4615 7.84615 18.3692 7.66154 18.1846L0.461538 10.4308L0.276923 10.1538Z"
                                fill="white"/>
                        </svg>
                    </span>
                    <span v-else>
                        PDF
                    </span>
                </div>
                <div class="training-certificate-tile__content">
                    <div class="training-certificate-tile__information">
                        <div class="training-certificate-tile__suptitle">
                            PDF
                        </div>

                        <div class="training-certificate-tile__title">
                            {{ additionalCourseContent.title }}
                        </div>
                        <p class="training-certificate-tile__description" v-if=" additionalCourseContent.description ">
                            {{ additionalCourseContent.description }}
                        </p>

                    </div>

                    <div class="training-certificate-tile__buttons">
                        <a class="btn btn--tertiary training-certificate-tile__button"
                           target="_blank"
                           :href="route('tenant.additional-course-content.view-upload', additionalCourseContent.id)">
                            Ansehen
                        </a>
                    </div>
                </div>
            </div>

        </div>

        <training-certificate-tile
            v-if="assignment.is_certifiable"
            :assignment="assignment"
        >
        </training-certificate-tile>
    </div>
</template>

<script>
export default {
    props: [
        'assignment',
        'courseProgress',
        'learningContents',
        'additionalCourseContents',
    ],
}
</script>
